import { render, staticRenderFns } from "./work-location.vue?vue&type=template&id=724ccc6f&"
import script from "./work-location.vue?vue&type=script&lang=js&"
export * from "./work-location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports